import ManageOrderProduct from './ManageOrderProduct';
import ManageOrderDetailProduct from './ManageOrderDetailProduct';

export {
  ManageOrderProduct,
  ManageOrderDetailProduct
};



// WEBPACK FOOTER //
// ./components/my-business/sub-view/manage-order/index.js